<script>
  // props
  import { getContext } from "svelte";
  import { useQuery } from "@sveltestack/svelte-query";
  import Loading from "../../../../components/pages/Loading.svelte";
  import { FetchError } from "../../../../utils/getData.js";

  /**
   * @type {string}
   */
  export let projectId

  export let executionId

  // error handlers
  const {handleFetchErrors} = getContext("fetchErrorHandler")

  // svelte-query
  const projectQuery = useQuery(`/api/auto-mps/projects/${projectId}/executions/${executionId}/LoadGraph/project.json`, {
    onError: err => {
      console.log(err)
      if (err instanceof FetchError) {
        handleFetchErrors(err.error)
      }
    },
    retry: false,
  })
  const resourcesQuery = useQuery(`/api/auto-mps/projects/${projectId}/executions/${executionId}/LoadGraph/resources.json`, {
    onError: err => {
      console.log(err)
      if (err instanceof FetchError) {
        handleFetchErrors(err.error)
      }
    },
    retry: false,
  })
</script>

{#if $projectQuery.data && $resourcesQuery.data}
  <slot
    projectId={projectId}
    project={$projectQuery.data}
    resources={$resourcesQuery.data}
  />
{:else}
  <Loading />
{/if}
